<ion-header
  class="ion-no-border"
  [ngClass]="{
    mart4: headerData?.mart4
  }"
>
  <ion-toolbar [ngClass]="headerData?.isSafeArea ? 'no-safe-area-top' : ''">
    <ion-buttons slot="start" *ngIf="headerData?.prevPageLink">
      <ion-back-button
        [defaultHref]="headerData?.prevPageLink"
        icon="chevron-back-outline"
        class="primary-icon-color"
        *ngIf="!headerData?.redirect"
      ></ion-back-button>
      <ion-button
        *ngIf="headerData?.redirect"
        (click)="backButtonClick.emit()"
        fill="clear"
        class="primary-icon-color"
      >
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="start" *ngIf="headerData?.modal">
      <ion-back-button
        defaultHref=""
        (click)="modalClose()"
        icon="chevron-back-outline"
        class="primary-icon-color"
      ></ion-back-button>
    </ion-buttons>

    <ion-title
      [ngClass]="{
        'ion-no-padding':true,
        font500: true,
        'primary-text-color': true,
        'fs-5': !headerData?.fs4,
        'fs-4': headerData?.fs4,
        marl20: headerData?.marl20,
        marl0: headerData?.marl0
      }"
    >
      <div
        class="title-class"
        [ngClass]="{
          'text-align-center': headerData?.textAlignCenter
        }"
      >
        <div class="scrollable-label-container">
          <ion-label class="header-primary-text-color scrollable-label">
            <span *ngIf="headerData?.title1">{{ headerData?.title1 }}</span>
            {{ headerData?.title | translate }}
          </ion-label>
        </div>
        <p class="fs-2 ion-no-margin font400 header-secondary-text-color">
          {{ headerData?.subtitle }}
        </p>
      </div>
    </ion-title>

    <ion-progress-bar
      type="indeterminate"
      *ngIf="headerData?.progressBar"
      class="l-spacing0"
    ></ion-progress-bar>

    <ion-buttons slot="end" *ngIf="headerData?.airportCode">
      <div
        (click)="presentModal()"
        lines="none"
        class="d-flex flex-col ion-align-items-center ion-margin-end primary-icon-color"
      >
        <ion-thumbnail slot="start" class="ion-no-margin">
          <custom-icon
            iconName="AIRPORT_ICON_SX"
            [width]="14"
            [height]="20"
          ></custom-icon>
        </ion-thumbnail>
        <ion-label class="ion-no-margin">
          <p
            class="fs-3 font500 paragraph-primary-text-color ion-no-margin mar0"
          >
            {{ headerData?.airportCode }}
          </p>
        </ion-label>
      </div>
    </ion-buttons>

    <ion-buttons slot="end" *ngIf="headerData?.showEdit">
      <ion-button
        [queryParams]="headerData?.editQueryParams"
        routerDirection="back"
        (click)="onEditButtonClick()"
      >
        <ion-icon
          class="fs-5 primary-icon-color"
          slot="icon-only"
          name="create-outline"
        ></ion-icon>
      </ion-button>

      <ion-img
        *ngIf="headerData?.currency == 'INR' && partnerPid === 'bfl'"
        src="assets/images/inr_img.png"
        class="inr-img-image"
      ></ion-img>
    </ion-buttons>

    <ion-buttons slot="end" *ngIf="headerData.showAdd">
      <ion-button (click)="headerData.addComponent()">
        <ion-icon
          class="primary-icon-color"
          slot="icon-only"
          name="add-outline"
        ></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end" *ngIf="headerData?.modalSlotEnd">
      <ion-button fill="clear" color="primary" (click)="modalClose()">
        <ion-icon
          slot="icon-only"
          name="close"
          class="primary-icon-color font24"
        ></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end" *ngIf="headerData?.endImage">
      <img [src]="headerData?.endImage" alt="" class="header-end-image" />
    </ion-buttons>

    <ion-buttons
      slot="end"
      *ngIf="
        headerData?.showLocation && (location || headerData?.airportInfo?.city);
        else showAirport
      "
      class="location-btn"
    >
      <ion-button fill="clear" color="primary" (click)="presentLocationModal()">
        <ion-icon name="location-outline" class="primary-icon-color"></ion-icon>
        <span>
          {{ location || headerData?.airportInfo?.city }}
        </span>
      </ion-button>
    </ion-buttons>

    <ng-template #showAirport>
      <ion-buttons
        slot="end"
        class="ion-padding"
        *ngIf="headerData?.airportCode"
      >
        <div
          (click)="presentModal()"
          lines="none"
          class="d-flex flex-row ion-align-items-center ion-margin-end primary-icon-color"
        >
          <ion-thumbnail slot="start" class="ion-no-margin padr10">
            <custom-icon
              iconName="AIRPORT_ICON_SX"
              [width]="14"
              [height]="20"
            ></custom-icon>
          </ion-thumbnail>
          <ion-label class="ion-no-margin">
            <p
              class="fs-3 font500 paragraph-primary-text-color ion-no-margin mar0"
            >
              {{ headerData?.airportInfo.airportCode }}
            </p>
          </ion-label>
        </div>
      </ion-buttons>
    </ng-template>

    <ion-buttons slot="end" class="marr10" *ngIf="headerData?.showGuestLogin && isGuestUser">
      <ion-button
        fill="clear"
        class="header-login-btn font500"
        (click)="openLoginModal()"
      >
        {{ 'login.login_btn' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
